import { DocumentData } from "@1games-ru/region-shared/dist/types/documents/documentData";
import clsx from "clsx";

function Field({ label, value, className }: { label?: string; value: string; className?: string }) {
  return (
    <div className={className}>
      <div className="text-dark-800/80 text-15">{label}</div>
      <div
        className={clsx(
          "text-left text-dark-800 text-14 uppercase",
          "py-2.5 border-b border-[#3D4E71]",
        )}
      >
        {value}
      </div>
    </div>
  );
}

export default function CriminalRecordCertificate({
  docNumber,
  issuedAt,
  issuer,
  owner,
  expiresAt,
}: DocumentData) {
  return (
    <div
      className={clsx(
        "flex flex-col w-[35.75rem] h-[31.25rem] rounded-[0.5rem] overflow-clip bg-[#EEF8FE]",
        "text-dark-800 p-[1.875rem]",
      )}
      style={{
        backgroundImage: "url(./svg/documents/criminal-certificate.webp)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <div className="flex items-center justify-between gap-5 h-[3.75rem]">
        <div className="w-[4rem]" />
        <div className="grow">
          <div className="text-[#3D4E71] text-16 font-medium">СПРАВКА О СУДИМОСТИ</div>
          <div className="text-[#3D4E71] text-15 mt-0.5">
            Главное управление министерства внутренних дел Региона
          </div>
        </div>
      </div>
      <div className="text-15 font-medium mt-5">№ 164301000</div>
      <div className="flex flex-col gap-5 mt-5">
        <div className="grid grid-cols-2 gap-5">
          <Field
            label="Имя Фамилия гражданина"
            value={[owner.lastName, owner.firstName].join(" ")}
          />
          <Field label="Паспорт гражданина РФ" value={String(docNumber)} />
        </div>
        <Field
          label="Имеются (не имеются) сведений о судимости (в том числе имевшейся ранее) на территории Российской Федерации"
          value="Не имеются"
        />
        <div className="grid grid-cols-2 gap-5">
          <Field label="Дата выдачи" value={issuedAt} />
          <Field label="Срок действия" value={expiresAt || "-"} />
        </div>
        <div className="grid grid-cols-2 gap-5">
          <Field label="Выдано начальником" value={issuer.name} />

          <div className="relative">
            <Field label="Подпись" value="-" />
            <img
              src="./svg/dark-signature.svg" // TODO: {issuer.signature}
              alt=""
              className="z-1 absolute h-[4rem] w-fit -bottom-[1rem] left-0 pointer-events-none"
            />
            <img
              src="./svg/documents/seal-police.webp"
              alt=""
              className="z-1 w-[6.25rem] aspect-square absolute -bottom-[2rem] right-0 pointer-events-none -rotate-12"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
